/**
 * Available AI models (Claude / Codex / Gemini)
 * Used by: AnalyzeModal, ImplementModal
 */
export const MODEL_OPTIONS = [
  { id: 'auto', name: 'Auto (Recommended)' },
  { id: 'opus-4.5-thinking', name: 'Claude 4.5 Opus (Thinking)' },
  { id: 'opus-4.5', name: 'Claude 4.5 Opus' },
  { id: 'sonnet-4.5', name: 'Claude 4.5 Sonnet' },
  { id: 'sonnet-4.5-thinking', name: 'Claude 4.5 Sonnet (Thinking)' },
  { id: 'gpt-5.2-codex', name: 'GPT-5.2 Codex' },
  { id: 'gpt-5.2-codex-high', name: 'GPT-5.2 Codex High' },
  { id: 'gpt-5.2-codex-xhigh', name: 'GPT-5.2 Codex Extra High' },
  { id: 'gpt-5.2-codex-fast', name: 'GPT-5.2 Codex Fast' },
  { id: 'gpt-5.2', name: 'GPT-5.2' },
  { id: 'gpt-5.2-high', name: 'GPT-5.2 High' },
  { id: 'gpt-5.1-codex-max', name: 'GPT-5.1 Codex Max' },
  { id: 'gpt-5.1-high', name: 'GPT-5.1 High' },
  { id: 'gemini-3-pro', name: 'Gemini 3 Pro' },
  { id: 'gemini-3-flash', name: 'Gemini 3 Flash' },
];

export const DEFAULT_MODEL = 'auto';
